import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  clearAdminMessages,
  fetchAdminUsersThunk,
  inviteAdminThunk,
  revokeAdminThunk,
  saveAdminThunk,
  selectAdminState,
  selectAdminUsers,
} from "../store/adminSlice";

export const useAdminManagement = () => {
  const dispatch = useDispatch();
  const state = useSelector(selectAdminState);
  const adminUsers = useSelector(selectAdminUsers);

  useEffect(() => {
    if (state.hasLoaded) return;
    dispatch(fetchAdminUsersThunk());
  }, [dispatch, state.hasLoaded]);

  useEffect(() => {
    if (!state.error && !state.successMessage) return undefined;

    const timeoutId = setTimeout(() => {
      dispatch(clearAdminMessages());
    }, 5000);

    return () => clearTimeout(timeoutId);
  }, [dispatch, state.error, state.successMessage]);

  const handleInviteUser = useCallback(
    async ({ firstname, lastname, email, role }) => {
      const action = await dispatch(
        inviteAdminThunk({ firstname, lastname, email, role }),
      );
      return inviteAdminThunk.fulfilled.match(action);
    },
    [dispatch],
  );

  const handleSaveUser = useCallback(
    async (updatedUser) => {
      const action = await dispatch(
        saveAdminThunk({ updatedUser, users: state.users }),
      );
      return saveAdminThunk.fulfilled.match(action);
    },
    [dispatch, state.users],
  );

  const handleRevokeAccess = useCallback(
    async (user) => {
      const action = await dispatch(revokeAdminThunk({ user, users: state.users }));
      return revokeAdminThunk.fulfilled.match(action);
    },
    [dispatch, state.users],
  );

  return {
    ...state,
    adminUsers,
    handleInviteUser,
    handleSaveUser,
    handleRevokeAccess,
  };
};

export default useAdminManagement;
